export const listFeeStructuresQuery = `
  query ListFeeStructures($input: ListFeeStructuresInput) {
    listFeeStructures(input: $input) {
      code
      feeStructures {
        id
        name
        feeCode
        billingPeriodId
        programId
        gradeId
        streamId
        amount
        description
        status
        version
      }
      totalElements
    }
  }
`;

export const createFeeStructureQuery = `
  mutation CreateFeeStructure($input: CreateFeeStructureInput!) {
    createFeeStructure(input: $input) {
      code
      feeStructure {
        id
        name
        billingPeriodId
        amount
        status
      }
    }
  }
`;

export const archiveFeeStructureMutation = `
  mutation ArchiveFeeStructure($input: ArchiveFeeStructureInput!) {
    archiveFeeStructure(input: $input) {
      code
      feeStructure {
        id
        name
        status
        version
      }
    }
  }
`;
